import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectNotifications,
  selectOldNotifications,
} from '@myStore/notifications/notifications.selector';
import { IAppState } from '@myStore/app.state';
import { INotification } from '@interfaces/INotification';
import {
  DeleteAllNotification,
  ReadNotifications,
  SubscribeToNotifications,
} from '@myStore/notifications/notifications.actions';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.sass'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: INotification[] = [];
  oldNotifications: INotification[] = [];
  private destroy$ = new Subject<boolean>();
  public userId: number | undefined;

  constructor(private _store: Store<IAppState>) {}

  ngOnInit(): void {
    this._store.pipe(select(selectNotifications)).subscribe(notifications => {
      if (notifications) {
        this.notifications = notifications;
      }
    });

    this._store
      .pipe(select(selectProfile), takeUntil(this.destroy$))
      .subscribe(profile => {
        if (profile) {
          this.userId = profile.id;
        }
      });

    if (this.userId)
      this._store.dispatch(new SubscribeToNotifications(this.userId));

    this._store
      .pipe(select(selectOldNotifications))
      .subscribe(notifications => {
        if (notifications) {
          this.oldNotifications = notifications;
        }
      });
  }

  deleteAllNotifications() {
    this._store.dispatch(new DeleteAllNotification());
  }

  isOldNotificationsEmpty() {
    return this.oldNotifications.length === 0;
  }

  isNewNotificationsEmpty() {
    return this.notifications.length === 0;
  }

  ngOnDestroy() {
    this._store.dispatch(new ReadNotifications());
  }
}
